import { componentSizeRoutine } from '@/store/modules/geometricBackground/routines'

export default {
  [componentSizeRoutine.TRIGGER](state, payload) {
    state.componentSize = payload
  }
}
